export type AppStateType = 'active' | 'inactive'
export function useAppState(): [AppStateType, AppStateType] {
  return ['active', 'active']
}
